import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/profile/account'

/**
 * Profile account service for account-level settings.
 */
class ProfileAccountService {
    /**
     * Delete the current account.
     *
     * @returns {Promise<Object>} Deletion response
     */
    async remove() {
        return await apiClient.delete(API_INTERNAL_BASE).then((response) => {
            return response.data
        })
    }

    /**
     * Update the current account profile.
     *
     * @param {Object} form - Account update payload
     * @returns {Promise<Object>} Updated account response
     */
    async update(form) {
        return await apiClient.put(API_INTERNAL_BASE, form).then((response) => {
            return response.data
        })
    }

    /**
     * Transfer account ownership to another admin user.
     *
     * @param {string} newOwnerUlid - ULID of the user to become the new owner
     * @returns {Promise<Object>} Transfer response
     */
    async transferOwnership(newOwnerUlid) {
        return await apiClient
            .post(API_INTERNAL_BASE + '/transfer-ownership', {
                new_owner_ulid: newOwnerUlid,
            })
            .then((response) => {
                return response.data
            })
    }
}

export default new ProfileAccountService()
